import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Clock, BatteryWarning, BrainCircuit } from 'lucide-react';
export function HookSection() {
  return <section className="py-20 bg-[#0f172a] relative border-t border-slate-800/50" data-id="element-152">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-153">
        <FadeIn data-id="element-154">
          <div className="text-center mb-12" data-id="element-155">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-156">
              El Cuarto Está Oscuro.{' '}
              <span className="text-amber-500" data-id="element-157">Tu Cerebro No.</span>
            </h2>
            <div className="w-24 h-1 bg-amber-500/50 mx-auto rounded-full" data-id="element-158"></div>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-159">
          <FadeIn delay={100} className="bg-slate-800/40 p-6 rounded-2xl border border-slate-700/50" data-id="element-160">
            <Clock className="w-10 h-10 text-red-400 mb-4" data-id="element-161" />
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-162">Las 2:45 AM</h3>
            <p className="text-slate-400 leading-relaxed" data-id="element-163">
              Estás acostado. Tenés sueño, pero tu cerebro está en 220v. Mirás
              el reloj y calculás cuántas horas te quedan antes de que suene la
              alarma.
            </p>
          </FadeIn>

          <FadeIn delay={200} className="bg-slate-800/40 p-6 rounded-2xl border border-slate-700/50" data-id="element-164">
            <BrainCircuit className="w-10 h-10 text-amber-400 mb-4" data-id="element-165" />
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-166">
              El Loop Infinito
            </h3>
            <p className="text-slate-400 leading-relaxed" data-id="element-167">
              Repasás lo que tenés que pagar mañana, el quilombo del laburo, lo
              que alguien te dijo o ese mail que no respondiste.
            </p>
          </FadeIn>

          <FadeIn delay={300} className="bg-slate-800/40 p-6 rounded-2xl border border-slate-700/50" data-id="element-168">
            <BatteryWarning className="w-10 h-10 text-orange-400 mb-4" data-id="element-169" />
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-170">
              El Cuerpo Grita
            </h3>
            <p className="text-slate-400 leading-relaxed" data-id="element-171">
              Sentís una opresión en el pecho, un nudo en el estómago y sabés
              que mañana vas a ser un ente arrastrándote por la vida.
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={400} data-id="element-172">
          <div className="bg-gradient-to-r from-slate-800/80 to-slate-900/80 p-8 rounded-2xl border border-slate-700 text-center" data-id="element-173">
            <p className="text-2xl md:text-3xl font-medium text-slate-200 leading-tight" data-id="element-174">
              No estás solo. No es tu culpa.
              <br data-id="element-175" />
              <span className="text-white font-bold mt-2 block" data-id="element-176">
                Solo te falta el botón de apagado.
              </span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}